import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    vouchers_title: "Ваучеры",
    vouchers_saveBtn: 'Сохранить',
    vouchers_add: 'Добавить',
    vouchers_saveFormSuccess: 'Данные успешно сохранены',
    vouchers_saveFormError: 'Не удалось сохранить данные',
    vouchers_errorLoadTable: 'Не удалось загрузить ваучеры',
    vouchers_district: 'Район',
    vouchers_quantity: 'Количество',
    vouchers_requiredField: 'Обязательное для заполнения',
    vouchers_enterNumbers: 'Введите только цифры',
    vouchers_errorSaveVoucherAmount:"Новое значение не может быть меньше {{count}}. Текущее количество выданных ваучеров: {{count}}"
  },
  kk: {
    vouchers_title: "Ваучерлер",
    vouchers_saveBtn: 'Сақтау',
    vouchers_add: 'Қосу',
    vouchers_saveFormSuccess: 'Деректер сәтті сақталды',
    vouchers_saveFormError: 'Деректерді сақтау сәтсіз аяқталды',
    vouchers_errorLoadTable: 'Ваучерлерді жүктеу мүмкін болмады',
    vouchers_district: 'Аудан',
    vouchers_quantity: 'Саны',
    vouchers_requiredField: 'Толтыру үшін міндетті',
    vouchers_enterNumbers: 'Сандарды ғана енгізіңіз',
    vouchers_errorSaveVoucherAmount: "Жаңа мән {{count}} кем болмауы керек. Ағымдағы берілген ваучерлер саны: {{count}}"
  }
});
